<template>
  <div class="wrapper">
    <div class="content">
      <img
        src="../../../assets/prograd/prograd-logo.png"
        class="prograd-logo"
      >
      <h1 class="center">
        Analyzing your data
      </h1>
      <span class="text">this might take up to 90 seconds</span>
      <div class="loader-container">
        <tiny-loader
          variant="secondary-black"
        />
      </div>
      <p
        class="link"
        @click="props.connectAccountsClicked"
      >
        Connect another bank account
      </p>
    </div>
  </div>
</template>

<script lang="ts" setup>
import TinyLoader from '@riseupil/base-ui/src/components/TinyLoader/TinyLoader.vue';
import Segment from '../../../Segment';

Segment.trackUserGot('ProgradOtsCashflowLoaderEntered');

const props = defineProps<{
  variant?: string,
  connectAccountsClicked:() => void;
}>();
</script>

<style lang="scss" scoped>
@import '../../../scss/riseup-vars';

.wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background-color: #E1F1F2;
  position: relative;
}

.content {
  display: flex;
  flex: 1;
  width: 100%;
  align-items: center;
  flex-direction: column;
}

.content h1 {
  color: #202125;
  font-size: 18px;
  font-family: CircularStdBook;
  font-weight: 700;
  line-height: 22px;
  word-wrap: break-word;
  margin-top: 56px;
  width: 80%;
  text-align: center;
  margin-bottom: 10px;
}

.content .text {
  color: #205441;
  font-size: 16px;
  font-family: CircularStdBook, sans-serif;
  font-weight: 450;
  line-height: 22px;
  word-wrap: break-word;
  margin-bottom: 50px;
}

.prograd-logo {
  margin-top: 150px;
  margin-bottom: 100px;
  width: 50%;
}

.link {
  position: absolute;
  bottom: 50px;
  color: #205441;
  font-size: 16px;
  font-family: CircularStdBook, sans-serif;
  font-weight: 450;
  line-height: 22px;
  word-wrap: break-word;
  cursor: pointer;
  text-decoration: underline;
  width: 100%;
  text-align: center;
}

.loader-container {
  width: 90%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>
